import React, { FC, useRef, useState } from 'react';
import { DownloadLink } from '../forms/ProductForm';

export const CopyIdButton: FC<{ id: string }>  = ({ id }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const timeoutRef = useRef<any>(null);

  return (
    <DownloadLink
      onClick={() => {
        try {
          if (id) {
            navigator.clipboard.writeText(id);

            setShowSuccess(true);
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current);
              timeoutRef.current = null;
            }
            timeoutRef.current = setTimeout(() => {
              setShowSuccess(false);
            }, 2500);
          }
        } catch (err) {
          //
        }
      }}
    >
    {
      showSuccess ? 'Kopiert!' : 'ID kopieren'
    }
    </DownloadLink>
  )
}
